import React from 'react';
type AdvisorsSvgProps = {
  stroke: string;
};

export const SavingsSvg: React.FC<AdvisorsSvgProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1055_4194)">
      <path
        d="M10 0.625C8.70738 0.625 7.65625 1.67613 7.65625 2.96875C7.65625 4.26137 8.70738 5.3125 10 5.3125C11.2926 5.3125 12.3438 4.26137 12.3438 2.96875C12.3438 1.67613 11.2926 0.625 10 0.625Z"
        fill={props.stroke}
      />
      <path
        d="M20 6.06954C20 5.01841 19.4158 4.07255 18.4756 3.60161L17.9504 4.64989C18.4917 4.92055 18.8281 5.46469 18.8281 6.06954C18.8281 6.82536 18.291 7.4329 17.5775 7.59102C16.5746 6.24563 14.9965 5.17559 13.092 4.60641C12.5006 5.71762 11.3442 6.48438 9.99998 6.48438C8.651 6.48438 7.49092 5.71227 6.90163 4.59462C6.56381 4.69856 6.2292 4.81962 5.90014 4.96005C4.28538 3.75555 3.50012 4.00005 1.50012 4.64989L1.00012 5.00005L2.20924 7.85653C2.00012 8.82813 2.14715 9.66758 2.00012 10L0.108696 10.5L0.108833 12.5L2.50012 13.5C2.95903 14.1352 3.42366 15.892 4.10745 16.3858L4.8553 19.375H8.24217V18.0601C9.40373 18.25 10.5962 18.25 11.7578 18.0601V19.375H15.1447L15.8926 16.3858C17.7368 15.0526 18.8281 13.1632 18.8281 11.1719C18.8281 10.2782 18.5989 9.42915 18.2164 8.63911C19.2607 8.24364 20 7.24622 20 6.06954ZM6.48436 10H5.31249V8.82813H6.48436V10Z"
        fill={props.stroke}
      />
    </g>
    <defs>
      <clipPath id="clip0_1055_4194">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
